import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "picture-slider-right",
  "use": "picture-slider-right-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"picture-slider-right\">\n    <path d=\"M15.5 2A1.5 1.5 0 0 0 14 .5H4.983a1.5 1.5 0 0 0-1.286.728l-3.003 5a1.5 1.5 0 0 0 0 1.544l3.003 5a1.5 1.5 0 0 0 1.286.728H14a1.5 1.5 0 0 0 1.5-1.5V2z\" fill=\"currentColor\" stroke=\"currentColor\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol